import { fromCodeData } from './CodeData.js';
import { Significance } from './Significance.js';
import {
  asBoolean,
  asInstant,
  mapDtoList,
  optionalEnum,
  optionalNumber,
  optionalString,
  requireNumber,
  requireObject,
} from './parse.js';

/**
 * Mirrors com.medprompt.content.codes.NewCode
 *
 * @typedef {object} NewCodeData
 * @property {string|null} codeId
 * @property {import('./CodeData.js').CodeData} record
 * @property {number} distance
 * @property {string|null} quote
 * @property {string|null} significance
 * @property {string|null} description
 * @property {number|null} duration
 * @property {number|string|null} date
 * @property {boolean} isSelected
 */

/**
 * @param {object} raw
 * @returns {NewCodeData}
 */
export function fromNewCodeData(raw) {
  const source = requireObject(raw, 'NewCode');
  return {
    codeId: optionalString(source.codeId),
    record: fromCodeData(source.record),
    distance: requireNumber(source, 'distance', 'NewCode'),
    quote: optionalString(source.quote),
    significance: optionalEnum(source.significance, Significance, 'NewCode', 'significance'),
    description: optionalString(source.description),
    duration: optionalNumber(source.duration),
    date: asInstant(source.date),
    isSelected: asBoolean(source.isSelected),
  };
}

/**
 * @param {unknown} raw
 * @returns {NewCodeData[]}
 */
export function fromNewCodeDataList(raw) {
  return mapDtoList(raw, 'NewCode', fromNewCodeData);
}
